const runtimeEnv = Object.fromEntries(
  Object.entries(window["env"] || {}).filter(([, value]) => value !== "")
);

export const env = { ...process.env, ...runtimeEnv };
